var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Loading", {
        attrs: { isLoading: _vm.saveLoading, text: _vm.loadText },
      }),
      _c(
        "Upload",
        {
          staticStyle: { display: "none" },
          attrs: {
            action: _vm.uploadImgUrl,
            data: _vm.uploadParams,
            format: ["jpg", "jpeg", "png", "gif"],
            accept: ".jpg,.jpeg,.png,.gif",
            "on-format-error": _vm.uploadError,
            "max-size": _vm.maxImgSize,
            "on-exceeded-size": _vm.checkImgSize,
            "on-success": _vm.quillImgSuccess,
            "on-error": _vm.quillImagError,
            "show-upload-list": false,
            "before-upload": _vm.quillImgBefore,
          },
        },
        [
          _c("Button", {
            ref: "imgUploadBtn",
            staticStyle: { display: "none" },
          }),
        ],
        1
      ),
      _c(
        "Upload",
        {
          staticStyle: { display: "none" },
          attrs: {
            action: _vm.uploadVivoUrl,
            format: ["mp4"],
            accept: ".mp4",
            data: _vm.uploadParams,
            "on-format-error": _vm.uploadError,
            "on-exceeded-size": _vm.checkVidoSize,
            "on-success": _vm.quillVidoSuccess,
            "show-upload-list": false,
            "on-error": _vm.quillVidoError,
            "max-size": _vm.maxVidoSize,
            "before-upload": _vm.quillVidoBefore,
          },
        },
        [
          _c("Button", {
            ref: "vidoUploadBtn",
            staticStyle: { display: "none" },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("quill-editor", {
            ref: _vm.toref,
            staticClass: "editor",
            style: { height: _vm.qillHeight + "px" },
            attrs: { options: _vm.editorOption },
            on: {
              blur: function ($event) {
                return _vm.onEditorBlur($event)
              },
              focus: function ($event) {
                return _vm.onEditorFocus($event)
              },
              change: function ($event) {
                return _vm.onEditorChange($event)
              },
            },
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }